/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const serviceSubscriptionsFlowNodes = Array.from(document.querySelectorAll('.service-subscriptions-flow'));
if (serviceSubscriptionsFlowNodes.length) {
    import(/* webpackChunkName: "ServiceSubscriptionsFlow" */ './components/ServiceSubscriptionsFlow').then(({ default: ServiceSubscriptionsFlow }) => {
        serviceSubscriptionsFlowNodes.forEach((node) => render(<ServiceSubscriptionsFlow {...parseDataToProps(node.dataset)} />, node));
    });
}
